import { styled as e, IconButton as t } from "@mui/joy";
import { commonBaseButtonStyles as a } from "./common/commonBaseButtonStyles.js";
const p = e(t)(({ theme: e2 }) => ({ ...a(e2), padding: e2.spacing(1) })), r = e(t)(({ theme: e2 }) => ({ svg: { fill: e2.palette.isDarkMode ? e2.palette.neutral[900] : e2.palette.primary[700] }, background: e2.palette.isDarkMode ? e2.palette.neutral[400] : e2.palette.primary[50], color: e2.palette.isDarkMode ? e2.palette.neutral[900] : e2.palette.primary[700], "&:hover": { background: e2.palette.isDarkMode ? e2.palette.neutral[500] : e2.palette.primary[100] }, gap: e2.spacing(1), padding: e2.spacing(1) }));
export {
  p as BaseIconButton,
  r as BaseIconButtonForGroup
};
//# sourceMappingURL=BaseIconButton.js.map
